import { generateSpectrum2D } from 'spectrum-generator';
export function signals2DToZ(signals, options = {}) {
    let { from = -1, to = 12, nbPoints = 512, width = 0.02, factor = 3, } = options;
    const peaks = signals.reduce((acc, { x, y }) => {
        acc.x.push(x.delta);
        acc.y.push(y.delta);
        acc.z.push(1e6);
        return acc;
    }, { x: [], y: [], z: [] });
    width = ensureXYNumber(width);
    return generateSpectrum2D(mergeClosePeaks(peaks), {
        generator: {
            from: ensureXYNumber(from),
            to: ensureXYNumber(to),
            nbPoints: ensureXYNumber(nbPoints),
        },
        peaks: {
            width,
            factor,
        },
    });
}
function ensureXYNumber(input) {
    return typeof input !== 'object' ? { x: input, y: input } : { ...input };
}
function mergeClosePeaks(peaksIn) {
    let peaks = JSON.parse(JSON.stringify(peaksIn));
    for (let i = 0; i < peaks.x.length; i++) {
        for (let j = i + 1; j < peaks.x.length; j++) {
            if (peaks.x[i] === peaks.x[j] && peaks.y[i] === peaks.y[j]) {
                peaks.z[i] += peaks.z[j];
                peaks.x.splice(j, 1);
                peaks.y.splice(j, 1);
                peaks.z.splice(j, 1);
                j--;
            }
        }
    }
    return peaks;
}
//# sourceMappingURL=signals2DToZ.js.map